import React from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import useLogin from "../hook/useLogin";

export default function PrivateRoute(props) {
  const { token } = useLogin();
  const { pathname } = useLocation();

  if (token) {
    if (pathname === "/") {
      return <Navigate to="/registros" />;
    } else {
      return <Outlet />;
    }
  } else {
    return <Navigate to={"/login"} />;
  }
}